import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompareReportViewComponent } from '../compare-report-view.component';

/**
 * Documents tab component
 * Displays the documents panel content for comparison
 * Renders the documentsTemplate from the parent component
 */
@Component({
    selector: 'app-compare-documents-tab',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="w-full h-full">
            @if (parentComponent && parentComponent.documentsTemplateRef) {
                <ng-container *ngTemplateOutlet="parentComponent.documentsTemplateRef"></ng-container>
            }
        </div>
    `
})
export class CompareDocumentsTabComponent implements OnInit {
    @Input() parentComponent?: CompareReportViewComponent;

    ngOnInit() {
        // Component initialized
    }
}

